<div class="header">
  <h1 class="mat-dialog-title">Add card</h1>
</div>
<mat-form-field *ngIf="!noAvailables">
  <mat-dialog-content>
    <mat-select
      name="cardType"
      [placeholder]="selectedValue"
      (selectionChange)="selectedValue = $event.value"
    >
      <mat-option *ngFor="let cardType of cardTypes" [value]="cardType">
        {{ cardType }}
      </mat-option>
    </mat-select>
  </mat-dialog-content>
</mat-form-field>

<div *ngIf="noAvailables">
  <p>No cards available to be added to this organisation!</p>
</div>

<mat-dialog-actions>
  <button mat-button (click)="close()">Cancel</button>
  <button
    *ngIf="!noAvailables"
    mat-raised-button
    color="primary"
    (click)="submit()"
  >
    Save
  </button>
</mat-dialog-actions>
